import { useState } from 'react'
import { CommonModal } from '../common'
import ConsentNotice from '../auth/ConsentNotice'
import CookiePolicy from '../auth/CookiePolicy'
import PrivacyPolicy from '../auth/PrivacyPolicy'
import TermsOfUse from '../auth/TermsOfUse'

const Footer = () => {
  const [modalOpen, setModalOpen] = useState({
    cookieModal: false,
    privacyModal: false,
    consentModal: false,
    termsOfUse: false,
  })
  return (
    <>
      <div className="flex justify-between items-center px-4 py-2 ">
        <p className="text-[#464646] text-[10px] font-normal flex-1 pr-4">
          ©2025 PwC. All rights reserved. PwC refers to the PwC network and/or one or more of its member firms, each of which is a
          separate legal entity. Please see
          <a
            href="https://www.pwc.com/structure"
            target="_blank"
            className="text-[#303030] mx-1"
          >
            pwc.com/structure
          </a>
          for further details.
        </p>
        <div className="flex items-center gap-4 text-xs leading-4 text-black whitespace-nowrap">
          <a
            onClick={() => setModalOpen({ ...modalOpen, consentModal: true })}
            className="underline cursor-pointer text-xs font-medium"
          >
            Legal notices
          </a>
          <a
            onClick={() => setModalOpen({ ...modalOpen, privacyModal: true })}
            className="underline cursor-pointer text-xs font-medium"
          >
            Privacy
          </a>
          <a
            onClick={() => setModalOpen({ ...modalOpen, cookieModal: true })}
            className="underline cursor-pointer text-xs font-medium"
          >
            Cookie policy
          </a>
          <a
            onClick={() => setModalOpen({ ...modalOpen, termsOfUse: true })}
            className="underline cursor-pointer text-xs font-medium"
          >
            Terms and conditions
          </a>
        </div>
      </div>

      <CommonModal
        open={modalOpen.cookieModal}
        onClose={() => setModalOpen({ ...modalOpen, cookieModal: false })}
        title={'Navigate Withholding Tax - Cookie Policy'}
        maxWidth="lg"
      >
        <CookiePolicy />
      </CommonModal>

      <CommonModal
        open={modalOpen.privacyModal}
        onClose={() => setModalOpen({ ...modalOpen, privacyModal: false })}
        title={'Navigate Withholding Tax - Privacy Policy'}
        maxWidth="lg"
      >
        <PrivacyPolicy />
      </CommonModal>

      <CommonModal
        open={modalOpen.consentModal}
        onClose={() => setModalOpen({ ...modalOpen, consentModal: false })}
        title={'Navigate Withholding Tax - Consent Notice'}
        maxWidth="lg"
      >
        <ConsentNotice />
      </CommonModal>

      <CommonModal
        open={modalOpen.termsOfUse}
        onClose={() => setModalOpen({ ...modalOpen, termsOfUse: false })}
        title={'Navigate Withholding Tax – Terms of Use'}
        maxWidth="lg"
      >
        <TermsOfUse />
      </CommonModal>
    </>
  )
}

export default Footer
